// @flow
import * as React from 'react'
import ApiService from '../../actions/apiService'
import {Row, Col, Input, Select, Button, DatePicker} from 'antd'
import { connect } from 'react-redux';
import moment from 'moment'
import ProfitChart from './ProfitChart'
import EquityChart from './EquityChart'
import {StyledContent, StyledCard} from './style'
import ComponentContainer from '../container-component'
const Option = Select.Option;
const { RangePicker} = DatePicker;

class Charts extends React.Component {
  
  state = {
    yearData: [],
    monthData: [],
    symbolData: [],
    strategyData: [],
    marketData: [],
    tradingData: [],
    tagCombinationData: [],
    tagData: [],
    isLoading: false,
    range: 'All',
    dateRange: [],
    selectedTag: '',
    selectedStrategy: '',
    selectedMarketType: '',
    selectedSymbol: ''
  }
  
  componentWillMount() {
    this.onApply();
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.account !== nextProps.account) {
      this.onApply(nextProps.account);
    }
  }
  
  onApply = (account) => {
    const data = {
      Account: account || this.props.account,
    }
    const { dateRange, selectedTag, selectedStrategy, selectedMarketType, selectedSymbol} = this.state;
    if (dateRange.length > 1) {
      data.startDate = dateRange[0].format('YYYY-MM-DD');
      data.endDate = dateRange[1].format('YYYY-MM-DD');
    }
    if (selectedTag) {
      data.Tag  = selectedTag;
    }
    if (selectedStrategy) {
      data.Strategy  = selectedStrategy;
    }
    if (selectedMarketType) {
      data.MarketType  = selectedMarketType;
    }
    
    if (selectedSymbol) {
      data.Symbol = selectedSymbol;
    }
    
    this.getData(data);
  }
  
  onReset = () => {
    this.setState({
      dateRange: [],
      selectedTag: '',
      selectedStrategy: '',
      selectedMarketType: '',
      selectedSymbol: '',
      range: 'All',
    }, () => {
      this.onApply()
    })
  }
  
  getData = async (data) => {
    this.setState({
      isLoading: true,
    })
    
    const equity = await ApiService.getProfitLoss('closedcumulativeprofitloss', data);
    const year = await ApiService.getProfitLoss('profitlossbyyear', data);
    const month = await ApiService.getProfitLoss('profitlossbymonthly', data);
    const symbol = await ApiService.getProfitLoss('profitlosspersymbol', data);
    const strategy = await ApiService.getProfitLoss('profitlossperstrategy', data);
    const market = await ApiService.getProfitLoss('profitlossbymarketcondition', data);
    const trading = await ApiService.getProfitLoss('profitlossbytradingsource', data);
    const tagCombination = await ApiService.getProfitLoss('profitlossbytagcombination', data);
    const tag = await ApiService.getProfitLoss('profitlossbytag', data);
    let yearData = [];
    let monthData = [];
    let symbolData = [];
    let strategyData = [];
    let equityData = [];
    let marketData = [];
    let tagCombinationData = [];
    let tagData = [];
    let tradingData = [];
    if (year) {
      yearData = year.map(item=> ({
        y: moment(item.profitLossDate).format('YYYY'),
        x: item.profitLoss,
      }))
    }
    if (month) {
      monthData = month.sort((a, b) => moment(a.profitLossDate) - moment(b.profitLossDate)).map(item=> ({
        y: moment(item.profitLossDate).format('MMM YY'),
        x: item.profitLoss,
      }))
    }
    if (symbol) {
      symbolData = symbol.map(item=> ({
        y: item.symbol,
        x: item.profitLoss,
      }))
    }
    if (strategy) {
      strategyData = strategy.map(item=> ({
        y: item.strategyGroupName,
        x: item.profitLoss,
      }))
    }
    if (equity) {
      equityData = equity.map(item=> ({
        y: moment(item.tradeDate).format('YYYY-MM-DD'),
        x: item.profitLoss,
      }))
    }
    if (market) {
      marketData = market.map(item=> ({
        y: item.marketConditionName,
        x: item.profitLoss,
      }))
    }
    if (trading) {
      tradingData = trading.map(item=> ({
        y: item.tradingSourceName,
        x: item.profitLoss,
      }))
    }
    if (tagCombination) {
      tagCombinationData = tagCombination.map(item=> ({
        y: item.tagCombination,
        x: item.profitLoss,
      }))
    }
    if (tag) {
      tagData = tag.map(item=> ({
        y: item.tag,
        x: item.profitLoss,
      }))
    }
    this.setState({
      yearData,
      monthData,
      symbolData,
      strategyData,
      equityData,
      marketData,
      tradingData,
      tagCombinationData,
      tagData,
      isLoading: false,
    })
  }
  
  selectDateRange = (range) => {
    const dateRange = [];
    if (range === 'CW') {
      dateRange[0] = moment().startOf("week");
      dateRange[1] = moment().endOf("week");
    } else if (range === 'CM') {
      dateRange[0] = moment().startOf("month");
      dateRange[1] = moment().endOf("month");
    } else if (range === 'YTD') {
      dateRange[0] = moment().startOf("year");
      dateRange[1] = moment();
    }
    
    this.setState({
      range,
      dateRange
    });
    
  }
  
  onDateRangeChange = (dates) => {
    const dateRange = [dates[0], dates[1]];
    this.setState({
      dateRange
    })
  }
  
  onSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  
  render() {
    const { yearData, monthData, symbolData, strategyData, equityData, isLoading, marketData, tradingData, tagCombinationData,
      tagData, range, dateRange, selectedTag, selectedStrategy, selectedMarketType, selectedSymbol } = this.state;
    return (
      <StyledContent>
        {
          isLoading &&
          <ComponentContainer
            title={'Loading Trade Data'}
            loading={isLoading}
            resetData={() => this.getData(this.props.account)}>
            <h1>Loading Trade Data</h1>
          </ComponentContainer>
        }
        {
          !isLoading &&
          <StyledCard title="Trade Data">
            <Row>
              <Col sm={3}>
               <div style={{paddingTop: 35}}> Symbol:</div>
                <Input name="selectedSymbol" value={selectedSymbol} onChange={this.onSelectChange} style={{width: 150}} />
              </Col>
              <Col sm={3}>
                <div style={{paddingTop: 35}}>Tag:</div>
                <Select value={selectedTag} style={{width: 150}} name="selectedTag" onChange={(val) => this.onSelectChange({target: {name: 'selectedTag', value: val}})}>
                  <Option value="">Select tag</Option>
                  <Option value="Broken Wing Iron Butterfly">Broken Wing Iron Butterfly</Option>
                  <Option value="Bear Call Spread">Bear Call Spread</Option>
                  <Option value="DPZ">DPZ</Option>
                  <Option value="V">V</Option>
                  <Option value="ADSK">ADSK</Option>
                  <Option value="SQ">SQ</Option>
                  <Option value="Ratio Back Spread">Ratio Back Spread</Option>
                </Select>
              </Col>
              <Col sm={3}>
                <div style={{paddingTop: 35}}>Strategy:</div>
                <Select value={selectedStrategy} style={{width: 150}} name="selectedStrategy" onChange={(val) => this.onSelectChange({target: {name: 'selectedStrategy', value: val}})}>
                  <Option value="">Select Strategy</Option>
                  <Option value="Bull Call Calendar + Earnings">Bull Call Calendar + Earnings</Option>
                  <Option value="Put Ratio Back Spread">Put Ratio Back Spread</Option>
                  <Option value="Earnings Dual Calendar">Earnings Dual Calendar</Option>
                  <Option value="Bear Put Calendar Pre Earning">Bear Put Calendar Pre Earning</Option>
                  <Option value="Iron Condor">Iron Condor</Option>
                  <Option value="Bull Put">D</Option>
                  <Option value="Broken Wing Iron Butterfly">Broken Wing Iron Butterfly</Option>
                </Select>
              </Col>
              <Col sm={4}>
                <div style={{paddingTop: 35}}>Market Type:</div>
                <Select value={selectedMarketType} style={{width: 150}} name="selectedMarketType" onChange={(val) => this.onSelectChange({target: {name: 'selectedMarketType', value: val}})}>
                  <Option value="">Select Market Type</Option>
                  <Option value="NA">NA</Option>
                </Select>
              </Col>
              <Col sm={7}>
                <div>Trade Date Range:</div>
                <Row style={{paddingBottom: 5}}>
                  <Col sm={4}><Button type={range === 'CW' ? 'primary' : ''} onClick={() => this.selectDateRange('CW')}>CW</Button></Col>
                  <Col sm={4}><Button type={range === 'CM' ? 'primary' : ''} onClick={() => this.selectDateRange('CM')}>CM</Button></Col>
                  <Col sm={4}><Button type={range === 'YTD' ? 'primary' : ''} onClick={() => this.selectDateRange('YTD')}>YTD</Button></Col>
                  <Col sm={4}><Button type={range === 'All' ? 'primary' : ''} onClick={() => this.selectDateRange('All')}>All</Button></Col>
                </Row>
                <Col sm={24}>
                  <RangePicker value={dateRange} onChange={this.onDateRangeChange} />
                </Col>
              </Col>
              <Col sm={4}  style={{paddingTop: 35}}>
                <Button type={'primary'} onClick={() => this.onApply()}>Apply</Button>
                <Button style={{marginLeft: 15}} onClick={this.onReset}>Reset</Button>
              </Col>
            </Row>
            <Row>
              <Col sm={23}>
                  <EquityChart height={600} data={equityData} title="Equity Curve"/>
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <ProfitChart height={500} data={yearData} title="Profit Loss By Year" />
              </Col>
              <Col sm={4} />
              <Col sm={10}>
                <ProfitChart height={500} data={monthData} title="Profit Loss By Month" />
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <ProfitChart height={500} data={marketData} title="Profit Loss By Market" />
              </Col>
              <Col sm={4} />
              <Col sm={10}>
                <ProfitChart height={500} data={tagData} title="Profit Loss By Tag" />
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <ProfitChart height={500} data={tagCombinationData} title="Profit Loss By Tag Combination" />
              </Col>
              <Col sm={4} />
              <Col sm={10}>
                <ProfitChart height={500} data={tradingData} title="Profit Loss By Trading" />
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <ProfitChart height={1200} data={symbolData} title="Profit Loss By Symbol"/>
              </Col>
              <Col sm={4} />
              <Col sm={10}>
                <ProfitChart height={1000} data={strategyData} title="Profit Loss By Strategy"/>
              </Col>
            </Row>
          </StyledCard>
        }
      </StyledContent>
    )
  }
}

const mapStateToProps = (state) => ({
  account: state.account.selectedAccount
})

export default connect(mapStateToProps, null)(Charts)



// WEBPACK FOOTER //
// ./src/components/view-positions/Charts.js